import * as React from 'react';
import { SVGProps } from 'react';

const IconExpandWidthSideSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M8 2h3v8H8V9h2V3H8V2Z" />
  </svg>
);
export default IconExpandWidthSideSizeXs;
